var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.508 1H1.508C1.23067 1 0.990667 1.10133 0.788 1.304C0.596 1.496 0.5 1.73067 0.5 2.008V14.008C0.5 14.2853 0.596 14.52 0.788 14.712C0.990667 14.904 1.23067 15 1.508 15H15.508C15.7853 15 16.02 14.8987 16.212 14.696C16.404 14.504 16.5 14.2747 16.5 14.008V2.008C16.5 1.73067 16.404 1.496 16.212 1.304C16.02 1.10133 15.7853 1 15.508 1ZM8.004 14.008H1.508V10.984H8.004V14.008ZM8.004 9.992H1.508V6.088H8.004V9.992ZM8.004 5.096H1.508V2.008H8.004V5.096ZM15.508 14.008H8.996V10.984H15.508V14.008ZM15.508 9.992H8.996V6.088H15.508V9.992ZM15.508 5.096H8.996V2.008H15.508V5.096Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.d8b07228888e930e90e3b8adbd21b2ca.svg";
export { ForwardRef as ReactComponent };